module.exports = __webpack_public_path__ + "img/codesign.2c42d531.png";